import { Col, Row } from "react-bootstrap"
import ProfileImage from "./ProfileImage"
import Label from "./Label"
import { ClientInfo } from "../api/users/data"

type UserInfoProps = {
    user  :ClientInfo
}

const UserInfo:React.FC<UserInfoProps> = ({user}) => {
    const bdate = new Date( user.BirthDate)
    const bdateFormatted = bdate.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
    const labelC = (label:string, value:string) => {
        return <Row><Col sm="1"><Label fontWeight="400" padding="0" color="gray" size="16px">{label}</Label></Col>
            <Col><Label fontWeight="400" size="16px">{value}</Label></Col>
        </Row>
    }
    return <Row style={{padding:"15px 0"}}>
        <Col sm="auto" style={{margin:"auto"}}>
            <ProfileImage name={user.LastName} bgcolor="#D9D9D9" size={60}/>
        </Col>
        <Col>
            <Label padding="0">{user.LastName + ", " + user.FirstName}</Label>
            {labelC("Id", user.ClientId)}
            {labelC("Email", user.ClientEmail)}
            {labelC("Mobile", user.ClientMobile)}
            {labelC("Birthdate", bdateFormatted)}
            { user.BirthPlace && labelC("Birthplace", user.BirthPlace) }
        </Col>
    </Row>
}

export default UserInfo